import './class-component-hooks'
import Vue from 'vue'
import SvgIcon from 'vue-svgicon'
import App from './App.vue'
import { sync } from 'vuex-router-sync'
import store from './store'
import router from './router'
import { price } from './utils/filters'
import BaseConfig from './data/baseconfig'

declare module 'vue/types/vue' {
  interface Vue {
    $t: (code: string) => string
    $theme: () => string
    $config: BaseConfig
  }
}

sync(store, router)
Vue.config.productionTip = false

Vue.use(SvgIcon, {
  isStroke: true,
  defaultWidth: '45px',
  defaultHeight: '45px'
})

Vue.filter('price', price)

Vue.prototype.$t = function (code: string): string {
  const args = arguments
  const defaultValue = (args.length > 1) ? args[1] : code
  return (this.$store.state.data.translations.hasOwnProperty(code))
    ? this.$store.state.data.translations[code]
    : defaultValue
}

Vue.directive('translate', function (this: Vue, el, binding, vnode) {
  if (vnode.context) {
    if (vnode.context.$store.state.debug) {
      el.classList.add('debug')
      el.setAttribute('data-title', binding.value)
    }
    el.innerHTML = (binding.arg)
      ? el.innerHTML.replace(`{${binding.arg}}`, vnode.context.$t(binding.value))
      : vnode.context.$t(binding.value)
  }
})

Vue.directive('edit', function (this: Vue, el, binding, vnode) {
  // console.log(vnode.context)
  if (vnode.context) {
    // console.log(`debug : ${vnode.context.$store.state.debug}`)
    // console.log(el)
    // console.log(binding.arg)
    // console.log(binding.value.item.id)
  }
})

Vue.prototype.$theme = function (): string {
  return this.$store.state.theme
}

// get external config
const configUrl = process.env.BASE_URL + 'config.json'
const ms = Date.now()
fetch(configUrl + '?cache=' + ms)
  .then((response) => response.json())
  .then((config) => {
    const baseConfig = Object.assign(new BaseConfig(), config)
    Vue.prototype.$config = baseConfig
    new Vue({
      render: (h) => h(App),
      router,
      store
    }).$mount('#app')
  }).catch((error) => { console.log(error) })
